import React, {useState, useEffect, useContext, Fragment} from 'react';
import styled from 'styled-components';
import {
  Input,
  Row,
  Col,
  Container,
  FormGroup
} from 'reactstrap';
import {QuestionAnswers} from '../../../../context';

const ListRows = props => {
  const {list, apply} = props

  return list.map((item) => (
    <tr key={`${item.number}`}>
      <td>
        {item.name}
      </td>
      <td>
        <Input
          min='0'
          max='100'
          type='number'
          value={item.value}
          onChange={e => apply(item.number, e.target.value)}
        />
      </td>
    </tr>
  ))
}

const PercentDistQuestion = props => {
  const {text, questionKey, repeat, choices, handleMultipleAnswers, markValid} = props
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)

  const answers=useContext(QuestionAnswers)

  useEffect(() => {

    let items = []
    function lineItem(repeat, questionKey, prefix, itemName) {
      for (let i=0; i < repeat; ++i) {
        const keyName = `${questionKey}-${prefix}${i}`
        const {[`${itemName}-${prefix}${i}`]: name} = answers
        const {[keyName]: value=0} = answers
        const itemText = `${prefix} - ${name}`
        const item = {
          number: items.length,
          name : itemText,
          value,
          keyName
        }
        items.push(item)
      }
    }

    const repeatAndPrefixs = repeat.split(',')
    const sectionNames = choices.split(',')
    for (let i=0; i < repeatAndPrefixs.length; ++i) {
      let [countName, prefix] = repeatAndPrefixs[i].split(':')
      countName = countName.trim()
      const {[countName.trim()]: repeat=0} = answers
      lineItem(repeat, questionKey, prefix.trim(), sectionNames[i].trim())
    }

    setList(items)
  }, [repeat, questionKey, answers, choices])

  useEffect(() => {
    function evaluateTotal() {
      const total = list.reduce((pv, cv) => {
        return pv + Number(cv.value) || 0
      }, 0)
      setTotal(total)
      if (total === 100) {
        markValid(true)
        handleMultipleAnswers(questionKey, total)
        // We keep the total in the questionKey to mark that the item is done
      } else {
        markValid(false)
        handleMultipleAnswers(questionKey, total)
      }
    }

    evaluateTotal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[list])

  function applyValue(number, value) {
    let tmp=[]
    Object.assign(tmp, list)
    tmp[number].value = value
    setList(tmp)
    handleMultipleAnswers(tmp[number].keyName, value === '' ? 0 : value)
  }

  return (
      <Container>
        <Row>
          <Col>
            <Fragment>
              <div style={{height:'40px'}} />
              <p>{text}</p>
              <p>[The total must add up to 100 percent]</p>
              <FormGroup>
              <table style={{width:'100%'}}>
                <thead>
                  <HeadTr>
                    <Th style={{width: '80%'}}>Name</Th>
                    <Th>Percent</Th>
                  </HeadTr>
                </thead>
                <tbody>
                  <ListRows list={list} apply={applyValue}/>
                  <tr>
                    <td>Total percent</td>
                    <td><Input value={total} readOnly invalid={total !== 100}/></td>
                  </tr>
                </tbody>
              </table>
              </FormGroup>
            </Fragment>
          </Col>
        </Row>
      </Container>
  )
};

const HeadTr = styled.tr`
  border-bottom: 1px solid rgba(0,0,0,0.2);
  height: 40px;
`;

const Th = styled.th`
  font-size: 14px;
  font-weight: 500;
`;

export default PercentDistQuestion;
